export default __webpack_public_path__ + "static/Lexend-Regular-02ff4e53ca0d5a659b633d21578af347.woff";